import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useFavorites } from "@/lib/favorites";

export const FavoriteButton = ({ id, label = false, className = "" }) => {
  const { has, toggle } = useFavorites();
  const on = has(id);
  const click = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toast.success(toggle(id) ? "Auf deiner Merkliste" : "Von der Merkliste entfernt");
  };
  return (
    <button onClick={click} aria-pressed={on} data-testid={`favorite-toggle-${id}`} title={on ? "Von Merkliste entfernen" : "Merken"}
      className={`lift flex items-center gap-1.5 border px-3 py-2 font-sub text-sm transition-colors ${on ? "border-terracotta bg-terracotta text-white" : "border-foreground/20 bg-white/70 text-foreground/70 hover:border-terracotta hover:text-terracotta"} ${className}`}>
      <Heart size={16} strokeWidth={1.5} className={`transition-transform duration-300 ${on ? "scale-110 fill-white" : ""}`} />
      {label && (on ? "Gemerkt" : "Merken")}
    </button>
  );
};
